module.exports = __webpack_public_path__ + "img/RECEIVE.b942a0f3.svg";